import BaseCom from "../../components/BaseCom";
import Card from "../../components/Card";
import L from "../../components/Lang";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";

class Dashboard extends BaseCom {
    render() {
        return (
            <div className="container-fluid">
                <h1><L>Developer Dashboard</L></h1>
                <Card title={<L>Welcome to the Developer Portal</L>}>
                    <p><L>Access comprehensive API documentation for the Apex LIS platform.</L></p>
                    <p><L>For questions or assistance feel free to email us at</L> <strong><a href="mailto:support@apexhealthware.com">support@apexhealthware.com</a></strong></p>
                </Card>
                <Card title="Architecture">
                    <div className="row">
                        <div className="col-md-8">
                            <p><L>In our deployment architecture, the API backend and the Laboratory Portal frontend run on separate servers for improved scalability, fault isolation, and maintenance flexibility. Despite being hosted on different compute instances or containers, both services reside within the same Virtual Private Cloud (VPC). This setup allows them to communicate securely and efficiently over the private network without exposing internal traffic to the public internet. The API handles core business logic, data access, and integration with external systems, while the Laboratory Portal focuses on user interaction and presentation. </L></p>
                            <h5><L>Rate Limiting AWS</L></h5>
                            <p><L>Our API enforces a Fixed Window rate limiting strategy to ensure fair usage and protect system stability.</L></p>
                            <p><L>Under this model, each API key is allowed a predefined number of requests within a fixed time window</L></p>
                            <p>~1000 <L>requests per</L> 30 <L>seconds</L></p>
                            <p className="text-muted"><L><i>Create Lab Order</i> is heaviest API request currently and is used to determine these limits.
                                Limits expand on read-only requests.</L></p>
                            <p><L>When a request is made, the system increments a counter associated with the API key in Redis. If this counter exceeds the allowed threshold within the window, further requests are rejected with a 429 Too Many Requests response.</L></p>
                            <p><L>The counter is automatically reset when the time window expires, thanks to Redis’s TTL (time-to-live) feature.</L></p>
                            <p><L>For more information review load request file:</L> <a href="/file/loadrequest-aws.csv" target="_blank" rel="noreferrer">loadrequest-aws.csv</a></p>
                            <h5><L>Rate Limiting Azure</L></h5>
                            <p>~300 <L>requests per</L> 60 <L>seconds</L></p>
                            <p className="text-muted"><L><i>Create Lab Order</i> is heaviest API request currently and is used to determine these limits.
                                Limits expand on read-only requests.</L></p>
                            <p><L>For more information review load request file:</L> <a href="/file/loadrequest-azure.csv" target="_blank" rel="noreferrer">loadrequest-azure.csv</a></p>
                        </div>
                        <div className="col-md-4 text-end">
                            <img src="/assets/img/arch.png" alt="" style={{width: '400px'}} />
                        </div>
                    </div>
                </Card>
                <Card title="Change Log">
                    <div className="lead d-flex justify-content-between">
                        <div className="text-dark">
                            Adding isRejected, rejectedReason to panel level in results API and webhook.
                        </div>
                        <div className="text-secondary">7/22/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">
                            Linked Get Lab Results PDF API to storage. Added Specimen Type List API. Added status to Get Lab Results Data API.
                        </div>
                        <div className="text-secondary">7/21/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">
                            Panel Note added to Get Lab Results Data API. Added Authorization Bearer token into webhook.
                        </div>
                        <div className="text-secondary">7/7/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Added results PDF API.</div>
                        <div className="text-secondary">7/3/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Added panel list API.</div>
                        <div className="text-secondary">6/26/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Added HL7 api call.</div>
                        <div className="text-secondary">6/25/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Demographic api calls added.</div>
                        <div className="text-secondary">6/23/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">IP filter properties in API Credentials</div>
                        <div className="text-secondary">6/13/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Collected date is now accepted as null.</div>
                        <div className="text-secondary">6/9/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Added load test documentation for Azure.</div>
                        <div className="text-secondary">6/4/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Added webhook retry count and retry delay and X-Event-ID header on webhooks.</div>
                        <div className="text-secondary">6/4/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Add collect order API.</div>
                        <div className="text-secondary">6/4/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Rotating encryption hotfix, skip null values to avoid rolling deployment delay.</div>
                        <div className="text-secondary">5/23/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Health checks added. Azure instance deployed.</div>
                        <div className="text-secondary">5/23/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Documentation added to dashboard. Rate limits implemented.</div>
                        <div className="text-secondary">5/14/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">API path has been modified from <s>/api/...</s> to <strong>/api/obs/...</strong></div>
                        <div className="text-secondary">4/28/2025</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-muted">Webhooks feature is now live and functional.</div>
                        <div className="text-secondary">4/28/2025</div>
                    </div>
                </Card>

            </div>
        );
    }
}

export default withParamsAndNavigate(Dashboard);